import { Event } from './event';

export class EnrolmentReviewCanceledEvent extends Event<void> {}
